/**
 * Map React Flow node types to the backend `result_type` string.
 * Used for credit cost estimation and validation.
 * Nodes not listed here (input/output/passthrough) are considered
 * cost-free.
 */
export const NODE_TYPE_TO_RESULT_TYPE = {
  imageEnhancement: 'enhance_photo',
  bgRemoval: 'background_removal',
  upscale: 'upscale',
  styleTransfer: 'style_transfer',
  nanoBanana: 'nano_banana',
  frameExtractor: 'frame_extractor',
  imageEdit: 'image_edit',
  banana2pro: 'banana2pro',
  imagen4Ultra: 'imagen4_ultra',
  seedance25: 'seedance_25',
  pixverseV6: 'pixverse_v6',
  eleV2: 'elevenlabs_v2',
  elTraductor: 'dubbing',
  lipSync: 'lipsync',
  musicPro: 'music_pro',
  avatarFast: 'avatar_fast',
  videoGeneration: 'create_video',
  videoWithSound: 'video_with_sound',
  dreamActor: 'dream_actor',
  fabricAvatar: 'fabric_avatar',
  klingAvatar: 'kling_avatar',
  lyria2: 'lyria2',
  qwen3tts: 'qwen3_tts',
  lyria3pro: 'lyria3_pro',
};

export const isProcessNodeType = (nodeType) =>
  Object.prototype.hasOwnProperty.call(NODE_TYPE_TO_RESULT_TYPE, nodeType);

export const resultTypeForNode = (nodeType) =>
  NODE_TYPE_TO_RESULT_TYPE[nodeType] || null;
